/** Transparent PNG lockups already used across the console */
export const PIVONY_LOGO_ON_DARK_BG = "/assets/pivony-logo.png";
export const PIVONY_LOGO_ON_LIGHT_BG = "/assets/pivony-logo1.png";
